import styled from 'styled-components';
import { Card } from '../CompanyPermissionSchemes/styles';
import { TopicStatus } from 'store/pdp/types';
import { blue, lightGray } from '../../../../utils/style/colors';

export const TagListContainer = styled('div')`
  width: 300px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 450px) {
    width: 100%;
  }
`;
export const TermsWrapper = styled('div')`
  overflow: hidden;
  display: flex;
  max-height: calc(100vh - 220px);

  flex-direction: row;
  flex-shrink: 1;
  flex-grow: 1;
`;

export const Container = styled(Card)`
  display: flex;
  height: calc(100% - 30px);
  flex: 1;
  overflow: scroll;
  //margin: 0;
  flex-direction: column;
  @media only screen and (max-width: 600px) {
    margin: 5px;
    padding: 10px 0;
  }
`;
export const PersonContainer = styled(Card)`
  max-width: 100%;
  display: flex;
  height: calc(100% - 30px);
  flex: 1;
  //margin: 0;
  flex-direction: column;
  @media only screen and (max-width: 450px) {
    margin: 5px;
    padding: 10px 0;
    flex: 1;
  }
`;

export const HContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const ApproveGroup = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ApproveGroupItem = styled('li')`
  :hover {
    background-color: ${lightGray};
  }
  border-radius: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TopicList = styled(Container)`
  height: 100%;
  overflow: auto;
  flex-grow: 1;
`;

export const TermEditorWrapper = styled(Card)`
  display: flex;
  padding: 0;
  flex-direction: column;
  width: calc(100% - 20px);
  flex-grow: 1;
  margin: 15px 10px;
  max-height: 100%;
  overflow: overlay;
`;

export const PDPEditorBody = styled('div')`
  display: flex;
  padding: 0;
  flex-direction: column;
  width: calc(100% - 20px);
  flex-grow: 1;
  margin: 0px 10px;
  max-height: 100%;
  overflow: overlay;
`;

interface TopicStateProps {
  state: TopicStatus | 'New' | 'Unknow';
  color: string;
}
export const TopicWrapper = styled('div')<TopicStateProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-radius: 10px;
  flex-direction: row;
  width: 250px;
  width: 100%;
  margin: 0;
  background-color: ${({ color }) => color};
`;

export const Header = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  border-bottom: 1px solid lightgray;
  margin: 0 15px 10px;
  padding-bottom: 10px;
`;

export const PhaseInfo = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const ErrorWrapper = styled('div')`
  & > div,
  & > span {
    margin: 10px 0;
    display: block;
  }
`;

interface PersonProps {
  inClass?: boolean;
}
export const PersonInList = styled('li')<PersonProps>`
  padding: 1px 10px;
  &:hover {
    color: ${blue} !important;
  }
  ${(props) => {
    return props.inClass ? 'list-style-type: none;' : '';
  }}
`;
export const PersonTopicList = styled('div')`
  display: grid;
  @media (min-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (min-width: 1250px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1500px) {
    grid-template-columns: repeat(3, 1fr);
  }
  column-gap: 10px;
`;

export const TopicItem = styled('div')`
  display: flex;
  cursor: pointer;
  width: 100%;
  &:not(:last-child) {
    border-bottom: 1px solid ${lightGray};
  }
  padding: 0.5rem;
`;
